import { Loader2 } from 'lucide-react';

export const Loading = ({ size = 'md', text = 'در حال بارگذاری...' }) => {
  const sizes = {
    sm: 'w-4 h-4',
    md: 'w-8 h-8',
    lg: 'w-12 h-12',
  };

  return (
    <div className="flex flex-col items-center justify-center gap-3">
      <Loader2 className={`${sizes[size]} animate-spin text-primary-600`} />
      {text && <p className="text-gray-600 text-sm">{text}</p>}
    </div>
  );
};